import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cmp-input-textarea',
  template: `<p>
  input-textarea works!
</p>
`,
  styles: [``]
})
export class InputTextareaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
